import React, { useState } from "react";
import { Button } from "react-bootstrap";

function AuditionNextIncDec() {
  const [value, setValue] = useState(0);
  return (
    <div className="bg-dark ">
      <div className="d-flex justify-content-around align-items-center  bg-dark p-2 ">
        <div className="d-flex justify-content-around align-items-center">
          <p className="text-light">Top</p>
        </div>
        <div className="d-flex justify-content-around align-items-center">
          <button
            className="btn btn-secondary text-warning fw-bold"
            onClick={() => {
              if (value < 0) {
                setValue(0);
              } else {
                setValue(parseInt(value) + 1);
              }
            }}
          >
            +
          </button>
        </div>
        <div className="d-flex justify-content-center align-items-center  ">
          <input
            type={`text`}
            className="form-control bg-dark  text-light text-center"
            value={`${value}`}
            onChange={(e) => setValue(e.target.value)}
          />
        </div>
        <div className="d-flex justify-content-center align-items-center">
          <h4 style={{ color: "white" }}>%</h4>
        </div>
        <div className="d-flex-justify-content-center align-items-center ">
          <button
            className="btn btn-secondary fw-bold text-warning "
            onClick={() => {
              if (value <= 0) {
                setValue(0);
              } else {
                setValue(parseInt(value) - 1);
              }
            }}
          >
            -
          </button>
        </div>
        <div className="d-flex justify-content-around align-items-center">
          <p className="text-light">Mark User quality for next round</p>
        </div>
      </div>
      <div className="text-center my-3">
        <button className="btn btn-warning fw-bold">Merge all videos</button>
      </div>
    </div>
  );
}

export default AuditionNextIncDec;
